import { Injectable } from "@angular/core";
import { ApiService, PagedResultGeneric } from "src/app/shared";
import { Contact } from "./contact.model";
import { ContactSearchDto } from "./contact-search.dto";


@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private _apiService: ApiService) {}

  get(contactId: number): Promise<Contact> {
    return this._apiService.get(`Contact/${contactId}`);
  }

  create(contact: Contact): Promise<Contact> {
    return this._apiService.post('Contacts', contact);
  }

  update(contact: Contact): Promise<Contact> {
    return this._apiService.put(`Contact/${contact.ContactId}`, contact);
  }

  search(search: ContactSearchDto, forceRefresh?: boolean): Promise<PagedResultGeneric<Contact>> {
    if (forceRefresh) {
      const cacheOpts = this._apiService.getDefaultApiCacheOptionsForNoCache();
      return this._apiService.getPaged('Contacts', search, cacheOpts);
    } else {
      return this._apiService.getPaged('Contacts', search);
    }
  }

  searchPost(search: ContactSearchDto): Promise<PagedResultGeneric<Contact>> {
    return this._apiService.post('Contacts/Search', search);
  }

  delete(contactId: number) {
    return this._apiService.delete(`Contact/${contactId}`);
  }
}
